import { BUYER_OUTREACH, LISTING_PACKAGE, MEDIA_PACKAGE } from 'models/Listing';

export const LISTING_PACKAGE_PRICES = {
  [LISTING_PACKAGE.BRONZE]: 2500,
  [LISTING_PACKAGE.SILVER]: 3500,
  [LISTING_PACKAGE.GOLD]: 5000,
  [LISTING_PACKAGE.BASIC]: 1300,
  [LISTING_PACKAGE.COMPREHENSIVE]: 2500,
  [LISTING_PACKAGE.NO_PACKAGE]: 0,
};

export const BUYER_OUTREACH_PRICES = {
  [BUYER_OUTREACH.TWO_WEEKS]: 1500,
  [BUYER_OUTREACH.FOUR_WEEKS]: 2500,
};

export const MEDIA_PACKAGE_PRICES = {
  [MEDIA_PACKAGE.TRIED_AND_TESTED]: 2000,
  [MEDIA_PACKAGE.TARGETED]: 2500,
  [MEDIA_PACKAGE.PRINT_PACKAGE]: 4500,
  [MEDIA_PACKAGE.THE_WORKS]: 5000,
};
